<template>
    <div>
        <div class="text-right">
            <button
                @click="handleDownload()"
                class="
                    px-4
                    py-2
                    mb-4
                    bg-gray-50
                    border
                    rounded-md
                    text-balck
                    flex
                "
            >
                <img src="../../../assets/excel.png" alt="" />
                <span class="mx-3">Download</span>
            </button>
        </div>

        <div class="flex text-lg mb-4">
            <h1 class="pr-4 border-r uppercase font-bold">
                {{ $route.params.reportOn.replace(/_/g, ' ') }}
            </h1>
            <h1 class="px-4 border-r">
                From:
                <span class="font-bold">{{
                    $route.params.from | moment('ddd, MMM Do YYYY')
                }}</span>
            </h1>
            <h1 class="px-4">
                To:
                <span class="font-bold">{{
                    $route.params.to | moment('ddd, MMM Do YYYY')
                }}</span>
            </h1>
        </div>
        <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
                <tr>
                     <th
                        scope="col"
                        class="
                            px-6
                            py-3
                            text-left text-xs
                            font-medium
                            text-gray-500
                            uppercase
                            tracking-wider
                        "
                    >
                        Date
                    </th>
                    <th
                        scope="col"
                        class="
                            px-6
                            py-3
                            text-left text-xs
                            font-medium
                            text-gray-500
                            uppercase
                            tracking-wider
                        "
                    >
                        Account Name
                    </th>
                    <th
                        scope="col"
                        class="
                            px-6
                            py-3
                            text-left text-xs
                            font-medium
                            text-gray-500
                            uppercase
                            text-left
                            tracking-wider
                        "
                    >
                        Opening Balance
                    </th>
                    <th
                        scope="col"
                        class="
                            px-6
                            py-3
                            text-left text-xs
                            font-medium
                            text-gray-500
                            uppercase
                            tracking-wider
                        "
                    >
                        Closing Balance
                    </th>

                      <th
                        scope="col"
                        class="
                            px-6
                            py-3
                            text-left text-xs
                            font-medium
                            text-gray-500
                            uppercase
                            tracking-wider
                        "
                    >
                        Running Balance
                    </th>

                      <th
                        scope="col"
                        class="
                            px-6
                            py-3
                            text-left text-xs
                            font-medium
                            text-gray-500
                            uppercase
                            tracking-wider
                        "
                    >
                        Actual Debits
                    </th>

                  
                </tr>
            </thead>

            <tbody
               
                class="bg-white divide-y divide-gray-200"
            >
                <tr  v-for="(report, i) in data.data" :key="i">
                      <td class="px-6 py-4 whitesspace-nowrap">
                        <div class="flex items-center">
                            <div class="">
                                <div class="text-sm font-medium text-gray-900">
                                    {{ report.date }}
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class="px-6 py-4 whitesspace-nowrap">
                        <div class="flex items-center">
                            <div class="ml-4">
                                <div class="text-sm font-medium text-gray-900">
                                      {{ report.account }}
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-left">
                        D
                            <b>{{
                                formatPrice(
                                    report.opening
                                )
                            }}</b>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900">
                          D
                          <b>{{
                                formatPrice(
                                    report.closing
                                )
                            }}</b>
                        </div>
                    </td>

                    <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900">
                            D
                            <b>
                                {{ formatPrice(report.running_balance) }}
                            </b>
                        </div>
                    </td>

                    <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900">
                            <b>
                                D
                                {{ formatPrice(debits(report)) }}
                            </b>
                        </div>
                    </td>

                   
                   
                </tr>

                <tr class="bg-gray-50">
                    <td class="px-6 py-4 whitespace-nowrap">
                        <div class="flex items-center">
                        <div class="ml-4">
                            <div class="text-sm font-medium text-gray-900">
                            <b>TOTAL</b>
                            </div>
                        </div>
                        </div>
                    </td>

                    <td class="px-6 py-4 text-center whitespace-nowrap">
                        
                    </td>

                    <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900">
                        D <b>{{ formatPrice(openingTotal) }}</b>
                        </div>
                    </td>

                    <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900">
                         D <b>{{ formatPrice(closingTotal) }}</b>
                        </div>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900">
                         <!-- GMD <b>{{ formatPrice(closingTotal) }}</b> -->
                        </div>
                    </td>

                    <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900">
                         D <b>{{ formatPrice(totalDebits) }}</b>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>


<script>
export default {
    props: ['data'],

    data: () => ({
        downloadLoading: false,

        filename: '',
        autoWidth: true,
        bookType: 'xlsx',
    }),

    computed: {
      openingTotal: function () {
        let total = [];

        Object.entries(this.data.data).forEach(([key, val]) => {
            console.log(key);
            total.push(val.opening / 100); // the value of the current key.
        });

        return total.reduce(function (total, num) {
            return total + num;
        }, 0);
      },

      closingTotal: function () {
        let total = [];

        Object.entries(this.data.data).forEach(([key, val]) => {
            console.log(key);
            total.push(val.closing / 100); // the value of the current key.
        });

        return total.reduce(function (total, num) {
            return total + num;
        }, 0);
      },

      totalDebits: function() {
        let total = []; // Initialize an empty array to hold the daily total debits

            // Loop through each day's data using Object.entries()
            Object.entries(this.data.data).forEach(([key, val]) => {
                // Call the debits() method to calculate the daily total debits
                console.log(key);
                let result = this.debits(val);
                total.push(result); // Add the daily total debits to the array
            });

            // Calculate the overall total debits by summing the daily totals in the array
            return total.reduce(function(total, num) {
                return total + num;
            }, 0);
        },
    },

    methods: {
        debits: function(data) {

            const openingBalance = data.opening;
            // const closingBalance = data.closing;
            const runningBalance = data.running_balance;
            const totalCredit = data.total_credit;
            // const totalDebit = data.total_debit;

            // Calculate total amount debited
            const totalDebited = (openingBalance + totalCredit) - runningBalance;

            // Get absolute value of total debited
            const absoluteTotalDebited = Math.abs(totalDebited);

            // return the final total
            return absoluteTotalDebited;
        },

        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace(',', '.');
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

        getFileName() {
            return (
                this.$route.params.reportOn +
                '-' +
                this.$route.params.from +
                '-' +
                this.$route.params.to
            );
        },

        handleDownload() {
            this.downloadLoading = true;
            import('@/vendor/Export2Excel').then(excel => {
                const tHeader = [
                    'Branch',
                    'Transactions',
                    'Amount',
                    'Commission',
                    'Total',
                ];
                const filterVal = [
                    'branch',
                    'transactions',
                    'amount',
                    'commission',
                    'total',
                ];
                const list = this.data;
                console.log('LIST', list);
                const data = this.formatJson(filterVal, list);
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: this.getFileName(),
                    autoWidth: this.autoWidth,
                    bookType: this.bookType,
                });
                this.downloadLoading = false;
            });
        },

        formatJson(filterVal, jsonData) {
            return Object.keys(jsonData).map(v => {
                console.log();
                return filterVal.map(j => {
                    console.log('J', j);
                    console.log();

                    if (j === 'branch') {
                        return v;
                    } else if (j === 'total') {
                        return (
                            Number(jsonData[v]['amount']) +
                            Number(jsonData[v]['commission'])
                        );
                    } else {
                        return jsonData[v][j];
                    }
                });
            });
        },
    },
};
</script>